<template>
  <div class="seu-header-mobile">
    <div class="logo-container">
      <router-link to="/">
      <img src="../../assets/logo/seu-logo.svg" alt="">
      </router-link>
    </div>
    <div v-if="menuOpened" @click="$emit('closeMenu')" class="burger-menu-container menu-close">
      <div class="burger-menu-button">
        <svg width="19" height="22" viewBox="0 0 19 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18.7188 19.6719C19.0938 20.1406 19.0469 20.8438 18.5781 21.2656C18.3438 21.4531 18.1094 21.5 17.875 21.5C17.5469 21.5 17.2188 21.4062 16.9844 21.125L10 12.7812L2.96875 21.125C2.73438 21.4062 2.40625 21.5 2.07812 21.5C1.84375 21.5 1.60938 21.4531 1.375 21.2656C0.90625 20.8438 0.859375 20.1406 1.23438 19.6719L8.5 11L1.23438 2.375C0.859375 1.90625 0.90625 1.20312 1.375 0.78125C1.84375 0.40625 2.54688 0.453125 2.96875 0.921875L10 9.26562L16.9844 0.921875C17.4062 0.453125 18.1094 0.40625 18.5781 0.78125C19.0469 1.20312 19.0938 1.90625 18.7188 2.375L11.4531 11L18.7188 19.6719Z"
            fill="currentColor"/>
        </svg>
      </div>
    </div>
    <div v-else @click="$emit('openMenu')" class="burger-menu-container menu-open">
      <div class="burger-menu-button">
        <svg width="21" height="18" viewBox="0 0 21 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 1.125C0 0.515625 0.46875 0 1.125 0H19.875C20.4844 0 21 0.515625 21 1.125C21 1.78125 20.4844 2.25 19.875 2.25H1.125C0.46875 2.25 0 1.78125 0 1.125ZM0 8.625C0 8.01562 0.46875 7.5 1.125 7.5H19.875C20.4844 7.5 21 8.01562 21 8.625C21 9.28125 20.4844 9.75 19.875 9.75H1.125C0.46875 9.75 0 9.28125 0 8.625ZM19.875 17.25H1.125C0.46875 17.25 0 16.7812 0 16.125C0 15.5156 0.46875 15 1.125 15H19.875C20.4844 15 21 15.5156 21 16.125C21 16.7812 20.4844 17.25 19.875 17.25Z"
            fill="currentColor"/>
        </svg>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "SeuHeaderMobile",
  props: {
    menuOpened: {
      type: Boolean,
    }
  }

}
</script>

<style lang="scss">
@import "SeuHeaderMobile.scss";
</style>
